export const Arrow = () => (
    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="-0.5" y="0.5" width="44" height="44" rx="22" transform="matrix(-1 0 0 1 44.5 0.5)" stroke="#3EA5F8" />
        <g clip-path="url(#clip0_154_141)">
            <path d="M22.4962 17.4181L28.9766 23.9505L22.4962 30.4829" stroke="#3EA5F8" />
            <path d="M29 23.9883H16.8431" stroke="#3EA5F8" />
        </g>
        <defs>
            <clipPath id="clip0_154_141">
                <rect width="32" height="32" fill="white" transform="matrix(-1 0 0 1 38.5 7.5)" />
            </clipPath>
        </defs>
    </svg>
)